<!-- Header Structure -->
<template>
  <div>

    <v-toolbar class="navbar-default" app fixed :clipped-left="!ifRtlLayout" :clipped-right="ifRtlLayout" >
      <!-- App Logo -->
      <div class="site-logo">
        <router-link to="/">
          <img src="/static/img/lovebaby.png" alt="site logo" width="50" height="50"></img>
          <small class="shop_name">{{shop_info.cn_name}}</small>
        </router-link>
      </div>

      <div class="left-nav">  
        <v-menu offset-y>
          <div slot="activator" class="drop-menu">
            <img width="30px" height="30px" src="/static/img/user-7.jpg" class="rounded-circle">
            <span>店内事务</span>
          </div>
          <v-list>
            <v-list-tile @click="add_vip()">
              <v-icon class="mr-3 font-lg text-gray iconfont" >icon-usherplus</v-icon>
              <v-list-tile-title>添加会员</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="show_dialog('SHOW_DIALOG_TAKE_CASH')">
              <v-icon class="mr-3 font-lg text-gray iconfont">icon-newbimoney</v-icon>
              <v-list-tile-title>提现</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  @click="show_dialog('SHOW_DIALOG_PAY_ORDER')">
              <v-icon class="mr-3 font-lg text-gray iconfont">icon-credit</v-icon>
              <v-list-tile-title>费用支出</v-list-tile-title>
            </v-list-tile> 
            <!-- <v-list-tile to="/session/login">
              <v-icon class="mr-3 font-lg text-gray">ti-receipt</v-icon>
              <v-list-tile-title>交接班</v-list-tile-title>
            </v-list-tile> -->
            <v-divider/>
              <v-list-tile   @click="$router.push('/admin/pages/miaosha_order')">
                <v-icon class="mr-3 font-lg text-gray iconfont">icon-list</v-icon>
                <v-list-tile-title>秒杀订单</v-list-tile-title>
              </v-list-tile>
            <v-divider/>

            <v-list-tile href='/front_admin.php'  target='_blank'>
              <v-icon class="mr-3 font-lg iconfont">icon-static</v-icon>
              <v-list-tile-title>数据</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>


         
      </div>

      <div class="left-nav">
        <!-- <v-toolbar-side-icon @click.stop="toggle_sidebar"></v-toolbar-side-icon> -->
        
        <v-btn icon  class="d-inline-50" href='/' target='_blank'>
          <i class="font-lg iconfont icon-source "></i>
        </v-btn>
         <v-btn icon @click="reset_order" class="d-inline-50">
          <i class="font-lg iconfont icon-refresh"></i>
        </v-btn>
        <v-btn icon @click="add_vip()" class="d-inline-50">
          <i class="font-lg iconfont icon-usherplus"></i>
        </v-btn>
        <v-btn icon @click="edit_sale_note_dlg('订单备注')" class="d-inline-50">
          <i class="font-lg iconfont icon-note-copy"></i>
        </v-btn>

        <v-btn icon @click="device_api.open_box()" class="d-inline-50">
          <i class="font-lg iconfont icon-unlock"></i>
        </v-btn>
        
        <v-btn icon  class="d-inline-50" @click="$router.push('/admin/pages/sale_orders')">
          <i class="font-lg iconfont icon-List"></i>
        </v-btn>
      </div>

      <v-spacer></v-spacer>
      <div class="pa-3"></div>
      <div class="right-nav">
        
        <v-btn icon @click="toggleFullScreen" class="d-inline-50">
          <i class="ti-fullscreen"></i>
        </v-btn>
        
        <v-menu offset-y class="d-inline-50">
          <v-btn icon slot="activator" >
            <v-icon class="mr-3 font-lg text-gray icon-message"></v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="item in items" :key="item.title" @click="">
              <v-icon class="">  {{item.icon}}</v-icon>
              <v-list-tile-title>{{item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        
        <v-menu offset-y>
          <div slot="activator" class="drop-menu">
            <img width="30px" height="30px" src="/static/img/user-7.jpg" class="rounded-circle">
            <span>{{(sysuser_info&&sysuser_info.name)?sysuser_info.name:""}}</span>
          </div>
          <v-list>
           <!--  <v-list-tile to="/users/user-profile">
              <v-icon class="mr-3 font-lg text-gray">ti-user</v-icon>
              <v-list-tile-title>个人信息</v-list-tile-title>
            </v-list-tile> -->
            
            <v-list-tile @click="user_logout">
              <v-icon class="mr-3 font-lg text-gray">ti-power-off</v-icon>
              <v-list-tile-title>退出</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <!-- Chat Searchbar 
    <v-navigation-drawer fixed v-model="chatSidebar" :width="250" :right="!rtlLayout" temporary app>
        <chat-sidebar></chat-sidebar>
    </v-navigation-drawer>
    -->
    <!-- <v-bottom-nav absolute :value="e31" :active.sync="e3" color="transparent">
      <v-btn flat color="teal">
        <span>Recents</span>
        <v-icon>history</v-icon>
      </v-btn>
      <v-btn flat color="teal">
        <span>Favorites</span>
        <v-icon>favorite</v-icon>
      </v-btn>
      <v-btn flat color="teal">
        <span>Nearby</span>
        <v-icon>place</v-icon>
      </v-btn>
    </v-bottom-nav> -->
    <dialog_user_input></dialog_user_input>
    <dialog_vip_edit></dialog_vip_edit>
    <dialog_take_money></dialog_take_money>
    <dialog_pay_order ></dialog_pay_order>
    
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'

import Sidebar from "../Sidebar/Sidebar.vue";
import ChatSidebar from "../ChatSidebar/ChatSidebar.vue";
import EventBus from "../../lib/eventBus";
import screenfull from "screenfull";
import {removeToken } from '@/lib/auth' // getToken from cookie
import g_mix from '@/mixin/g_sale'
import device_api from "@/api/local_device"
import dialog_user_input from "../../views/front_sale/dialogs/dialog_user_input";
import dialog_vip_edit from "../../views/front_sale/dialogs/dialog_vip_edit";
import dialog_take_money from "../../views/front_sale/dialogs/dialog_take_money";
import dialog_pay_order from "../../views/front_sale/dialogs/dialog_pay_order";


export default {
  mixins:[g_mix],
  data() {
    return {
      device_api,
      collapsed: false, // collapse sidebar
      chatSidebar: false, // chat component right sidebar
      sidebarImages: "", // sidebar background images
      enableSidebarBackground: false,
      enableDefaultSidebar: false,
      rtlLayout: false,
      ifRtlLayout:false,
      searchFormOpen: false,
      items: [
        // {
        //   title: "Total App Memory",
        //   icon: "storage"
        // },
        // {
        //   title: "Total Memory Used",
        //   icon: "memory"
        // },
        // {
        //   title: "12 Unread Mail",
        //   icon: "mail"
        // },
        // {
        //   title: "Feedback",
        //   icon: "feedback"
        // }
      ],
      e31:true,
      e3:1,
    };
  },
  computed: {
    ...mapGetters(['sysuser_info','shop_info']),
  },
  methods: {
    
    show_dialog(id){
        this.$store.commit(id,true)
    },
    add_vip(){
        this.$store.commit("SHOW_DIALOG_EDITVIP",'add')
    },
    reset_order(){
      this.confirm_dlg("确定要重置此单？").then(_=>{
        this.$store.commit("PRODUCTS_LIST_CLEAN")
        this.$store.commit('VIP_SET_VIP_INFO',{})
        this.$store.commit('VIP_SET_VIP_SAVED',[])
        this.$store.commit('PRODUCTS_PREPARE_LIST',[])
        this.$store.commit('SHOW_DIALOG_ACTIVE_TAB','tab-sale')
      })
    },
    toggleFullScreen() {
      if (screenfull.enabled) {
        screenfull.toggle();
      }
    },
    searchFormHanler() {
      this.searchFormOpen = !this.searchFormOpen;
    },
    user_logout(){
      let self = this;
      this.$store.dispatch('act_worker_logout').then(data=>{
          removeToken();
          self.$router.push('/login')
      })
    },
  },
  components: {
    appSidebar: Sidebar,
    ChatSidebar,
    dialog_user_input,
    dialog_vip_edit,
    dialog_take_money,
    dialog_pay_order

  }
};
</script>
<style>
  .left_menu {
    color: #fff;
    font-size: 1.25rem;
    border-right: 2px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
    height: 50px;
    width: 50px;
    margin: 0;
  }
  /*.theme--light .toolbar.navbar-default, .theme--dark .toolbar.navbar-default{
  }*/
  .navbar-default{
          background :#438EB9 !important;
  }
  .shop_name{
     color:white; 
     font-size: 1rem;
     bottom: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue